module.exports = __webpack_public_path__ + "static/media/galerija_2017 (41).c397dfb3.jpg";